(function() {
  var CFG = window.__ipLocalization;
  if (!CFG) return;

  function resolve(isoCode) {
    isoCode = (isoCode || '').toString().toUpperCase().trim();
    if (!isoCode) return fallback();

    var inMarket = CFG.marketCountries.indexOf(isoCode) !== -1;

    var countryInfo = null;
    var continentName = null;

    // 优先通过 iso_code 匹配
    for (var i = 0; i < CFG.continents.length; i++) {
      var regions = CFG.continents[i].regions || [];
      for (var j = 0; j < regions.length; j++) {
        var r = regions[j];
        if (r.iso_code && r.iso_code.toString().toUpperCase() === isoCode) {
          countryInfo = r;
          continentName = CFG.continents[i].continent;
          break;
        }
      }
      if (countryInfo) break;
    }

    // 若元字段没有 iso_code，用 Intl.DisplayNames 获取国家名后再匹配 region
    if (!countryInfo) {
      var countryName = null;
      try {
        var dn = new Intl.DisplayNames(['en'], { type: 'region' });
        countryName = dn.of(isoCode);
      } catch (e) {}
      if (countryName) {
        for (var i = 0; i < CFG.continents.length; i++) {
          var regions = CFG.continents[i].regions || [];
          for (var j = 0; j < regions.length; j++) {
            var r = regions[j];
            if (r.region && r.region === countryName) {
              countryInfo = r;
              continentName = CFG.continents[i].continent;
              break;
            }
          }
          if (countryInfo) break;
        }
      }
    }

    var displayName, displayCurrency, displayIsoCode;

    // 1. 店铺市场包含用户ip对应的国家
    if (inMarket) {
      displayName = countryInfo ? countryInfo.region : CFG.fallbackCountryName;
      displayCurrency = countryInfo && countryInfo.currency ? countryInfo.currency : CFG.fallbackCountryCurrency;
      displayIsoCode = isoCode;
    } else { // 2. 店铺市场不包含用户ip对应的国家,那么就使用(主题自定义)section.settings中设置的默认名字，货币使用店铺默认货币
      displayCurrency = CFG.shopCurrency || CFG.fallbackCountryCurrency;
      displayName = CFG.defaultRegionName || CFG.fallbackCountryName;
      // if (countryInfo && continentName) {
      //   displayName = continentName;
      //   displayCurrency = countryInfo.currency || CFG.shopCurrency || CFG.fallbackCountryCurrency;
      // } else {
      //   displayName = CFG.defaultRegionName || CFG.fallbackCountryName;
      // }
      displayIsoCode = isoCode;
    }

    return { displayName: displayName, displayCurrency: displayCurrency, displayIsoCode: displayIsoCode };
  }

  function fallback() {
    return {
      displayName: CFG.fallbackCountryName,
      displayCurrency: CFG.fallbackCountryCurrency,
      displayIsoCode: CFG.fallbackCountryIsoCode
    };
  }

  function updateUI(data) {
    if (!data) return;

    var toggles = document.querySelectorAll('[data-ip-toggle-text]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].textContent = data.displayName + '(' + data.displayCurrency + ')';
    }

    var titles = document.querySelectorAll('[data-ip-modal-title]');
    for (var i = 0; i < titles.length; i++) {
      titles[i].textContent = data.displayName + '(' + data.displayCurrency + ')';
    }

    var tpl = CFG.currencyDescription || '';
    var nameHtml = '<span class="currency-selector-modal__name">' + data.displayName + '</span>';
    var currencyHtml = '<span class="currency-selector-modal__name">' + data.displayCurrency + '</span>';
    var subtitles = document.querySelectorAll('[data-ip-modal-subtitle]');
    for (var i = 0; i < subtitles.length; i++) {
      subtitles[i].innerHTML = tpl
        .replace(/\[\[region\]\]/g, nameHtml)
        .replace(/\[\[currency\]\]/g, currencyHtml);
    }
  }

  if (window.__ipLocalizationInitialized) return;
  window.__ipLocalizationInitialized = true;

  function init() {
    var cacheKey = 'syrokan_ip_country_iso';
    var cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      try { updateUI(resolve(cached)); } catch (e) {}
      return;
    }

    fetch('https://api.syrokan.cc/', { method: 'GET' })
      .then(function(res) { return res.text(); })
      .then(function(text) {
        var iso = (text || '').trim();
        if (iso) {
          sessionStorage.setItem(cacheKey, iso);
          updateUI(resolve(iso));
        }
      })
      .catch(function() {
        // API 失败时保持 Liquid fallback，不报错
      });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
